export const FEATURE_FLAGS = {
  EMAILS: 'emails',
  POWER_USER: 'power-user',
  WARRANTIES: 'warranties',
  PRODUCTS: 'products',
  NOTIFICATIONS: 'notifications',
  TRACKSTAR: 'trackstar',
  AUTO_SHOPIFY_PRODUCT_SYNC: 'auto-shopify-product-sync',
  PRODUCT_CSV_UPLOAD: 'product-csv-upload',
  ENGINEERING_DASHBOARD: 'engineering-dashboard',
  ENGINEER_IMPERSONATION: 'engineer-impersonation',
  INFO_MODALS: 'info-modals',
  INFO_MODAL_VISUAL_BUILDER: 'info-modal-visual-builder',
  CLAIM_RESET: 'claim-reset',
  RISE_AI: 'rise-ai',
  EXTENDED_WARRANTIES: 'extended-warranties',
  CLAIM_AUTOMATION: 'claim-automation',
  AUTOMATION_PRE_FETCH: 'automation-pre-fetch',
  // Compacts pre-fetched tool payloads in the automation agent prompt (strip empty values, JSON→YAML).
  AUTOMATION_COMPACT_PREFETCH_BE: 'automation-compact-prefetch-be',
  // Writes one claim_automation_tool_run row per tool call of each automation run.
  AUTOMATION_TOOL_RUN_TABLE_BE: 'automation-tool-run-table-be',
  // Validates a captured write-tool payload before it becomes a suggestion; on failure the
  // model is handed the errors and retries.
  AUTOMATION_WRITE_VALIDATION: 'automation-write-validation',
  // Escalation kind and trigger, the AI's recommended resolution on judgement escalations, approving it, and the
  // Control Panel. Evaluated per store on the backend; valet hides the UI when it is off for the user.
  ESCALATION_RECOMMENDATIONS: 'automation-escalation-recommendations',
  // Approves an escalation's recommendation once it has waited the auto-approve window. Evaluated per store. Default off.
  ESCALATION_AUTO_APPROVE: 'automation-escalation-auto-approve',
  AUTOMATION_AUTO_EXECUTE: 'automation-auto-execute',
  AUTOMATION_EXECUTION_SLACK_NOTIFICATION: 'automation-execution-slack-notification',
  AUTOMATION_COURSE_CORRECTION: 'automation-course-correction',
  // Gates the "Regenerate" button on an active AI suggestion (re-runs the agent).
  AUTOMATION_REGENERATE: 'automation-regenerate',
  // Gates the "Stop" button shown while the AI is analyzing a claim.
  AUTOMATION_STOP: 'automation-stop',
  // Gates the "Generate SOPs from {help desk}" card on the SOPs settings page.
  SOP_HELPDESK_IMPORT: 'sop-helpdesk-import',
  // Gates the "Generate SOPs from Slack" card on the SOPs settings page.
  SOP_SLACK_IMPORT: 'sop-slack-import',

  // SUBSCRIPTIONS
  ORDERGROOVE: 'ordergroove',
  RECHARGE: 'recharge',
  // Off: the Recharge OP reconcile only logs what it would remove. On: it deletes orphaned OP one-times.
  RECHARGE_OP_RECONCILE: 'recharge-op-reconcile',
  STAY_AI: 'stay-ai',
  SMARTRR: 'smartrr',

  // add _BE and -be for backend specific feature flags (or add more allowed backendsuffixes)
  NOTIFICATIONS_BE: 'notifications-be',

  // Dual-write claim events to Yofi Data API (v2) alongside v1 webhook.
  YOFI_V2_DATA_API_BE: 'yofi-v2-data-api-be',

  // Process inbound Yofi/Wyllo v2 prediction webhooks (claim.predicted).
  WYLLO_WEBHOOK_BE: 'wyllo-webhook-be',

  // ENG-6179 — sends claim events and order notes to Yofi (v1 webhook + v2 Data API). Yofi is no longer
  // a vendor, so this stays off; on restores the old outbound feed. Default off.
  YOFI_OUTBOUND_BE: 'yofi-outbound-be',

  // Extended warranty widget decision feature flag for gradual rollout
  ENABLE_EXTENDED_WARRANTY_WIDGET_BE: 'enable-extended-warranty-widget-be',

  // Warranty product exclusion feature flag
  WARRANTY_EXCLUSIONS: 'warranty-exclusions',
  WARRANTY_EXCLUSIONS_BE: 'warranty-exclusions-be',

  PRODUCT_TAXONOMY: 'product-taxonomy',

  // Per-claim-type warranty resolution options
  WARRANTY_RESOLUTION_OPTIONS: 'warranty-resolution-options',

  // Gates the Settings > Policy Builder tab (per-store coverage matrix).
  POLICY_BUILDER: 'policy-builder',

  // Gates the Risk Routing card under Settings > Policy Builder.
  RISK_ROUTING: 'risk-routing',

  VALET_SHOPIFY_SESSION_EXCHANGE: 'valet-shopify-session-exchange',

  // Developer Platform & Marketplace
  DEVELOPER_PLATFORM: 'developer-platform',
  DEVELOPER_PAT: 'developer.pat',
  MARKETPLACE: 'marketplace',

  // Skio subscription provider — gates both the integration schema (so it
  // doesn't appear in the integrations list) and the SkioWebhooksController.
  // Default off; remove once we've verified addSubscriptionLine isOneTime
  // semantics across a few real merchants.
  SKIO: 'skio',

  // Loop Subscriptions (LoopWork) provider — gates the integration schema and the
  // LoopworkWebhooksController. Default off until verified on a live Loop store.
  LOOPWORK: 'loopwork',

  // Live carrier tracking data on the claim view page.
  // Gates the "Tracking Updates" card under each fulfillment and the Ship24-backed
  // /v1/orders/:id/tracking-status fetch it triggers.
  SHOW_LIVE_TRACKING_UPDATES: 'show-live-tracking-updates',

  // ENG-5607 — Custom Tag Rules under Settings > Tagging. Gates both the
  // valet UI card and metadata-svc's CustomTagFlowService.applyForEvent.
  // Per-store rollout via store-id targeting. Default off.
  ENABLE_CUSTOM_TAG_RULES: 'enable-custom-tag-rules',

  // ENG-4126 — Global-E international reshipment integration. One flag gates
  // every piece: primary-market sync + backfill (shopify-svc), the integration
  // schema visibility in dispatch listSchemas, and the reship routing branch
  // through Global-E CreateOrder. Default off; per-store rollout via targeting.
  GLOBALE_INTEGRATION: 'globale-integration',

  // ENG-5603 — guards the partner v2 work (new partner cohort APIs + the
  // shapeQuoteResponse refactor on /v1/quote/insurance that emits partner
  // attribution fields). Flag-on opts into the new shared shaper / partner v2
  // surface; flag-off falls back to the pre-refactor inline shape so live
  // shopper traffic can roll back with one toggle if the new shaper drifts.
  // Remove once verified across production.
  PARTNER_V2_BE: 'partner-v2-be',

  // Selects the active carrier-tracking provider in orders-svc. Multivariate string flag whose value
  // is the provider name: 'aftership' (default) or 'ship24'. The selected provider registers trackers,
  // ingests its webhooks, and backs tracking reads; the other provider's webhook endpoint stays
  // mounted but acks-and-skips. A single knob (vs. per-provider booleans) that flips the provider
  // without a redeploy. Requires the selected provider's API key (+ webhook secret) in env.
  TRACKING_PROVIDER: 'tracking-provider',

  // ENG-5611 — Public Analytics API (analytics-svc). Service-wide enable /
  // kill-switch for every /v1/analytics/* endpoint. Canaried on a multi-store
  // beta account (Hexclad) via LaunchDarkly targeting. Default off.
  ANALYTICS_API_V1: 'analytics-api-v1',

  // PD-3210 — Rex (dispatch-svc) posts a Claude analysis as a threaded reply
  // under MetaBot's automated Metabase reports. Service-wide kill-switch for the
  // whole trigger→analysis path. Default off until verified in prod.
  METABASE_REPORT_ANALYSIS_BE: 'metabase-report-analysis-be',

  // ENG-5791 — dispatch-svc evaluates the sentiment of customer messages on
  // AI-resolved claims (one-shot LLM call) and posts a Slack alert when a
  // resolution landed badly. Kill-switch for the whole evaluate→alert path
  // (each evaluation is an LLM call, so this also caps spend). Default off.
  AUTOMATION_NEGATIVE_FEEDBACK_MONITOR_BE: 'automation-negative-feedback-monitor-be',

  // ENG-5989 — after a resolution is written, claims-svc verifies that what was promised
  // actually landed. Gates ALERTING only: rows are written regardless, so the delta
  // distribution is measurable during the log-only period. Default off.
  RESOLUTION_DELIVERY_VERIFICATION_BE: 'resolution-delivery-verification-be',

  // Exposes the get_resolution_pricing tool to the claim-automation agent: an ephemeral
  // calculator that prices the model's stated judgment (nothing persisted). Default off.
  AUTOMATION_RESOLUTION_PRICING_BE: 'automation-resolution-pricing-be',

  // A pure-money AI approval (every claim item REFUND / STORE_CREDIT, no reship) must carry a priced
  // `intent`; one priced by the model through claim_items is refused at capture and again at
  // execution. Per-store rollout via LD store context. Default off.
  AUTOMATION_REQUIRE_PRICED_INTENT_BE: 'automation-require-priced-intent-be',

  // Route claim-automation Kimi calls through OpenRouter (BYOK) for billed per-call cost, with Claude Sonnet as
  // OpenRouter's model fallback. If every model fails, the run fails (failure alert); turn this off to go back to
  // direct. Per-store via LD store context. Default off.
  AUTOMATION_OPENROUTER_GATEWAY_BE: 'automation-openrouter-gateway-be',

  // Pin a store's claim-automation runs to the OpenRouter provider set on its ai_model (ai_model.provider), e.g.
  // DigitalOcean for Kimi K2.6. Only applies to runs on the gateway. Per-store via LD store context. Default off.
  AUTOMATION_MODEL_PROVIDER_ROUTING_BE: 'automation-model-provider-routing-be',

  // Load a store's macros into the claim-automation system prompt and drop search_macros from the agent's tools,
  // so macros are read from the cached prompt instead of an extra call. Per-store via LD store context. Default off.
  AUTOMATION_MACROS_IN_PROMPT_BE: 'automation-macros-in-prompt-be',

  // Per-claim-type AI escalation guardrail with queue tiers. Gates the valet editor, whether
  // merchant-svc returns/accepts the thresholds (so they never reach the agent's prompt when off),
  // and the agent's access to get_platform_claims_summary. Per-store rollout via LD store context.
  AUTOMATION_ESCALATION_GUARDRAIL: 'automation-escalation-guardrail',

  // ENG-5621 — Gates the on-demand "Generate Affidavit" button on the valet
  // claim page, which enqueues the existing CreateClaimAckFileTask to render the
  // ACKNOWLEDGEMENT ClaimDocument. Global on/off (rolled out to Hexclad). Default off.
  AFFIDAVIT_ON_DEMAND: 'affidavit-on-demand',

  // ENG-5800 — Reviews triage layer on valet /reviews: "Mark checked" control,
  // notes drawer ("Order Protection notes" for brands), and checked/has-notes
  // filter chips. UI-only gate for a staged rollout (the backend routes are
  // entitlement-gated and ship dark). Default off.
  REVIEWS_TRIAGE: 'reviews-triage',

  // ENG-5850 — Gates the reseller-only "Account Admin" area in valet (/account-admin), where a Parent
  // Account manages the Brands and Child Accounts in its tree and flips each Child Account's finance
  // visibility. A GLOBAL kill-switch only: valet's LD client is anonymous, so this cannot target a
  // single reseller — the per-tenant gate is the server-resolved `hierarchy.isParent` on userinfo.
  // MUST be created client-side available (usingEnvironmentId) or the area never renders. Default off.
  //
  // This is the ONLY flag ENG-5850 uses. The Analytics dashboards (Surface B) use the same global
  // kill-switch in addition to isParent/isInHierarchy and their own visibility toggles. Backend
  // suppression is gated on the per-account settings row — an account with no row resolves
  // fully-visible, so the server side remains inert until a reseller is configured.
  ACCOUNT_PARENTS_ADMIN: 'account-parents-admin',

  // Concierge scoped access — staged rollout of the front-door and guest-session guards.
  // Multivariate: 'off' | 'log' | 'enforce'. LOG lets denials through but records them, so a caller
  // nobody remembered surfaces in logs rather than as a customer-facing 403. Default off.
  CONCIERGE_SCOPED_ACCESS_MODE: 'concierge-scoped-access-mode',

  // ENG-5796 — On-demand AI product finder on the offline/in-store "I can't find
  // the item" path in Concierge. Gates the finder step only; the plain not-found
  // form stays reachable underneath, so flipping this off restores today's flow.
  // Each run costs an LLM call, so this doubles as a spend cap. Default off.
  OFFLINE_PRODUCT_FINDER: 'offline-product-finder',

  // ENG-5871 — Reads the customer's uploaded receipt and fills in the product name and description
  // for them. Separate from the finder flag above on cost grounds: the finder runs only when a
  // search fails, this runs on every in-store claim that carries a receipt, and a vision call is
  // the most expensive request either of them makes. The two are independent — a prefilled
  // description is worth having even with the finder off, since it reaches the agent on the claim.
  // Default off.
  OFFLINE_RECEIPT_PREFILL: 'offline-receipt-prefill',

  // ENG-5925 — AI status badges, automation filter, and sort control on the valet To Do
  // claim queue. Client-side available (usingEnvironmentId). Default off; internal OP
  // account first.
  CLAIM_QUEUE_AI_BADGES: 'claim-queue-ai-badges',

  // ENG-5925: dispatch-svc mirrors claim state + automation events to the store's account
  // channel so the claim queue receives cross-user updates. Kill switch for Ably fan-out
  // volume on large accounts. Default off, and on/off only — a percentage rollout resolves
  // to `env.on` in resolveServedVariation and would turn it on environment-wide, while
  // per-account targeting needs dispatch-svc to wire LAUNCHDARKLY_SDK_KEY the way claims-svc
  // now does and to read this through getFeatureFlagForContext.
  QUEUE_REALTIME_ACCOUNT_CHANNEL_BE: 'queue-realtime-account-channel-be',

  // ENG-5925 Phase 2 — claim assignment control on the valet claim detail page.
  // Client-side available (usingEnvironmentId). Default off.
  CLAIM_ASSIGNMENT: 'claim-assignment',

  // A customer reply on a final-state claim reopens it to NEW. claims-svc now triages the message
  // first (one-shot LLM call, same criteria file as the negative-feedback monitor); when this flag
  // is on for the store, a benign reply — no follow-up needed, not NEGATIVE, confident, no
  // attachments — leaves the claim in its final state. Off logs what it would have kept and reopens
  // as before, so the verdicts can be audited before any store is enabled. Default off.
  SURFACE_FAILED_AUTOMATION_EXECUTIONS_BE: 'surface-failed-automation-executions-be',
  POST_RESOLUTION_BENIGN_REPLY_BE: 'post-resolution-benign-reply-be',

  // ENG-5991 — claims-svc triages negative reactions to AI resolutions (customer messages and CSAT
  // reviews) into a lane: AI decision, AI message, execution, slow, policy, external. Gates the
  // lane classification and review sentiment, both LLM calls, per store. Default off.
  REACTION_LANE_CLASSIFICATION_BE: 'reaction-lane-classification-be',

  // ENG-6034 — brand escalation routing: Valet "Move to On Hold" Brand action and the dispatch-svc
  // Slack card / fallback email fan-out. Client-side available (usingEnvironmentId). Default off.
  CLAIM_BRAND_HOLD_ROUTING: 'claim-brand-hold-routing',

  // ENG-6112 — brand Slack card replies save as regular internal notes; a verified one lifts a brand hold.
  BRAND_SLACK_REPLY_AUTOMATION: 'brand-slack-reply-automation',

  // A Slack reply on a claim card lands as an internal note, and every one of them starts an AI run.
  // When this flag is on for the store, claims-svc first asks Jev whether the reply gives the claim
  // handler anything to act on; chatter ("looking into it", a question to a teammate) is saved as a
  // note but neither starts a run nor lifts a brand hold. Off, or when Jev is unavailable, every
  // reply triggers as before. Default off.
  SLACK_NOTE_ACTION_GATE_BE: 'slack-note-action-gate-be',
  // ENG-6377 — Jev audits each executed AI claim decision after the fact. Per-store, default off.
  AUTOMATION_AI_DECISION_AUDIT_BE: 'automation-ai-decision-audit-be',

  // ENG-6362 — dispatch asks claims-svc for the note gate's verdict before it writes a brand-thread Slack
  // message as a note, so each message gets one Jev call. Per store. Default off.
  BRAND_THREAD_DECISION_GATE_BE: 'brand-thread-decision-gate-be',

  // ENG-6179 — per-store fraud check. Every claim is scored at creation either way; off stores keep the
  // report as a hidden shadow row for calibration. On shows it to the AI as Fraud Info, writes the
  // [Fraud Check] note on medium/high, and stops HIGH claims from auto-approving. Default off.
  FRAUD_CHECK_BE: 'fraud-check-be',

  // ENG-6376 — per-store off switch for the fraud check's shared-address points. Off stores still look the
  // address up and store its counts, but score and stamp the scheme-a.2 table. Default on: a missing flag or
  // a failed evaluation keeps the points.
  FRAUD_CHECK_ADDRESS_BE: 'fraud-check-address-be',

  // ENG-6124 — Rex restates a direction in a brand's order post ("I'm understanding that you want me to …"). Default off.
  REX_INQUIRY_REPLY: 'rex-inquiry-reply',

  // ENG-6117 — a verified brand note that approves a switched-off resolution method (e.g. refund) unlocks it on that one claim. Default off.
  BRAND_APPROVED_DISABLED_METHOD: 'brand-approved-disabled-method',

  // ENG-6372 — tell the agent how long ago a DNR or Stolen claim was delivered. Per-store, default off.
  AUTOMATION_DELIVERY_WINDOW_FACT_BE: 'automation-delivery-window-fact-be',

  // Evri hands UK-to-international parcels to a cross-border partner and its public feed (what
  // AfterShip and Ship24 read) posts a single "On hold" scan at that handoff, then nothing until
  // final delivery. The partner's own portal has the full history, so orders-svc reads it for
  // Evri shipments and serves those events instead. Interim until the carrier feed carries the
  // partner leg. Default off.
  EVRI_PORTAL_TRACKING_FALLBACK_BE: 'evri-portal-tracking-fallback-be',

  // Valet claims + warranties queues: a resolved claim a customer replies to comes back as NEW while
  // still carrying its resolution. On, those claims leave To Do for a Re-Opened tab (own count,
  // own filter); off, To Do lists and counts them as before. claims-svc always serves the split
  // counts, so the frontend folds `reopened` back into To Do when this is off. Client-side
  // available (usingEnvironmentId). On in every environment.
  CLAIM_REOPENED_TAB: 'claim-reopened-tab',

  // Claim automation extraction (SR-5): string flag setting which service processes automation work, one of
  // ClaimAutomationProcessorOwner ('claims-svc', 'both', 'claim-automation-svc'); flips always pass through 'both'.
  // Default and fallback 'claims-svc', so an absent, unknown, or unreachable value keeps today's behavior.
  CLAIM_AUTOMATION_PROCESSOR_OWNER: 'claim-automation-processor-owner-be',

  // ENG-61 — Custom-domain TLS via GCP Certificate Manager (per-domain certs).
  // Off: whitelabel domains go through the legacy Go whitelabel-svc ingress path.
  WHITELABEL_GCP_PROVISIONING_BE: 'whitelabel-gcp-provisioning-be',

  // Off: merchant-svc only logs the Maps browser key referrer diff. On: it writes the referrer list
  // (Order Protection hosts plus every whitelabel custom domain) to the key.
  MAPS_KEY_REFERRER_SYNC_BE: 'maps-key-referrer-sync-be',

  // Fluid claim-resolution reshipments: create the $0 replacement order in one
  // call via Fluid's Order Import API (POST /v2025-06/orders) instead of the
  // legacy 6-call cart-checkout simulation with a placeholder payment method.
  // Flag-off keeps the cart flow. Default off until staging verifies imported
  // orders enter the merchant's fulfillment pipeline.
  FLUID_RESHIP_ORDER_IMPORT_BE: 'fluid-reship-order-import-be',

  // Per-user Fluid admin login via App Bridge session tokens
  // (POST /v1/fluid/session/exchange). Replaces the owner-only DRI exchange
  // once Fluid wires the droplet embed surface to its bridge host. Default off.
  FLUID_SESSION_LOGIN_BE: 'fluid-session-login-be',

  // Kill switch for included-in-shipping coverage (ENG-6130): while it's off, every store behaves as OP_LINE.
  INCLUDED_IN_SHIPPING_BE: 'included-in-shipping-be',
  // Valet's included-in-shipping UI on Settings › Policies (ENG-6218). Client-side only. Default off.
  INCLUDED_IN_SHIPPING: 'included-in-shipping',

  // Red Pulse partner payouts (ENG-6244): shows the Account Admin "Payouts" tab (the partner's payout
  // history) and the Finance Admin "Partner Payouts" tab. Client-side only (usingEnvironmentId). Default off.
  PARTNER_PAYOUTS: 'partner-payouts',

  // Customer info pages (ENG-3663): valet's new /customers search and detail pages and the analytics-svc session
  // routes behind them. Client-side (usingEnvironmentId) and read globally on the backend. Default off.
  CUSTOMER_INFO_PAGES: 'customer-info-pages',
  // Customer summary tiles and backend summary from analytics_tables.customer_summary_view (ENG-6279).
  // Client-side (usingEnvironmentId) and read globally on the backend. Default off.
  CUSTOMER_ROLLUP_VIEWS: 'customer-rollup-views',
  // Customer History strip on valet's claim view (ENG-6295), client-side (usingEnvironmentId) and default off.
  CUSTOMER_HISTORY_STRIP: 'customer-history-strip',

  // Seasonal dashboard themes in valet (Admin → Themes): makes every season's theme available. Which season is live is
  // engineering's "On for everyone" switch on the Themes page (stored in identity-svc); each user can also turn a season
  // off for themselves. The key predates the other seasons; LaunchDarkly flag keys cannot be renamed. Default off.
  SEASONAL_THEMES: 'halloween-theme',

  // Post-resolution automation v1: when a resolved/closed/denied claim is reopened by a customer message that is
  // a simple question answerable from claim/order/resolution data (refund status, store-credit code, replacement
  // status), the AI answers it and restores the exact prior terminal state. Per-store, read on the backend.
  // Gates whether the answer job runs + is audited at all. Default off.
  POST_RESOLUTION_AUTOMATION_BE: 'post-resolution-automation-be',

  // Execute gate for the above. Off = shadow mode: the job classifies and records the would-be answer for review
  // but sends nothing and does not restore state. On = it sends the answer and restores the prior state.
  // Lets a store run in shadow first, then go live without a code change. Per-store, default off.
  POST_RESOLUTION_AUTOMATION_EXECUTE_BE: 'post-resolution-automation-execute-be',
} as const;
